/* @ngInject */
export default function config(
  $compileProvider,
  $httpProvider,
  $locationProvider,
  $provide,
  $qProvider,
  $sailsProvider,
  $uibTooltipProvider,
  $windowProvider,
  appConfig,
  growlProvider,
  uibButtonConfig,
  uiSelectConfig,
  vsRepeatConfigProvider,
) {
  const $window = $windowProvider.$get();
  $sailsProvider.config = {
    url: appConfig.apiBaseUrl,
    uri: appConfig.apiBaseUrl,
    autoConnect: false,
    reconnection: true,
    transports: ['websocket'],
    useCORSRouteToGetCookie: true,
    headers: { url: $window.location.hostname }
  };

  // Angular event system debugging
  const EVENT_DEBUGGING_ENABLED = false;
  if (EVENT_DEBUGGING_ENABLED) {
    $provide.decorator('$rootScope', ($delegate) => {
      const Scope = $delegate.constructor;
      const origBroadcast = Scope.prototype.$broadcast;
      const origEmit = Scope.prototype.$emit;

      /* eslint-disable prefer-rest-params */
      Scope.prototype.$broadcast = function () {
        console.debug(`$broadcast called on $scope ${this.$id}:`, arguments);
        return origBroadcast.apply(this, arguments);
      };
      Scope.prototype.$emit = function () {
        console.debug(`$emit called on $scope ${this.$id}:`, arguments);
        return origEmit.apply(this, arguments);
      };
      /* eslint-enable prefer-rest-params */
      return $delegate;
    });
  }

  $httpProvider.defaults.withCredentials = true;

  // location
  $locationProvider.html5Mode(true).hashPrefix('');

  // https://docs.angularjs.org/guide/production
  $compileProvider.debugInfoEnabled(!PRODUCTION);

  // TODO: remove line line and correct errors it generates. (selecting row in /admin/dataUsage)
  // https://docs.angularjs.org/api/ng/provider/$qProvider
  $qProvider.errorOnUnhandledRejections(false);

  // growl
  growlProvider.globalTimeToLive({
    success: 3000,
    error: 7000,
    warning: 5000
  });
  growlProvider.globalPosition('top-center');

  // Override for default `active` class which breaks `btn` styling
  // https://github.com/angular-ui/bootstrap/tree/master/src/buttons
  uibButtonConfig.activeClass = 'btn-primary';
  // uiSelect
  uiSelectConfig.theme = 'select2';

  vsRepeatConfigProvider.silenceSizeMismatchWarnings();

  if (_.isUndefined(window.EventTarget)) {
    const eventTarget = document.createDocumentFragment();
    window.EventTarget = Object.create(
      _.reduce(
        ['addEventListener', 'removeEventListener'],
        (memo, val) => _.assign(memo, { [val]: eventTarget[val] }),
        {}
      )
    );
  }

  const deviceAgent = navigator.userAgent.toLowerCase();
  if ((/(applewebkit.*mobile)/i).test(deviceAgent)) {
    $uibTooltipProvider.options({ trigger: 'dontTrigger' });
  }
}
